import React from "react";

function BookingsArt() {
  return (
    <>
      <rect x="86" y="36" width="148" height="148" rx="22" fill="#fff" stroke="#f0a8aa" strokeWidth="2.5" />
      <rect x="86" y="36" width="148" height="38" rx="22" fill="#fdecec" />
      <rect x="86" y="56" width="148" height="18" fill="#fdecec" />
      <rect x="118" y="28" width="28" height="18" rx="5" fill="#c6272a" />
      <rect x="174" y="28" width="28" height="18" rx="5" fill="#c6272a" />
      <rect x="114" y="92" width="36" height="28" rx="6" fill="#fdecec" />
      <rect x="158" y="92" width="36" height="28" rx="6" fill="#f8d0d1" />
      <rect x="202" y="92" width="16" height="28" rx="6" fill="#f3f4f6" />
      <rect x="114" y="128" width="36" height="28" rx="6" fill="#f3f4f6" />
      <rect x="158" y="128" width="36" height="28" rx="6" fill="#fdecec" />
      <rect x="202" y="128" width="16" height="28" rx="6" fill="#f8d0d1" />
    </>
  );
}

function CustomersArt() {
  return (
    <>
      <circle cx="132" cy="92" r="28" fill="#fdecec" />
      <circle cx="132" cy="84" r="14" fill="#c6272a" />
      <path d="M108 124c4-16 16-24 24-24s20 8 24 24" fill="#f8d0d1" />
      <circle cx="196" cy="100" r="24" fill="#fff" stroke="#f0a8aa" strokeWidth="2.5" />
      <circle cx="196" cy="93" r="12" fill="#c6272a" />
      <path d="M176 128c3-14 13-20 20-20s17 6 20 20" fill="#fdecec" />
      <rect x="98" y="138" width="124" height="36" rx="18" fill="#fff" stroke="#ececec" strokeWidth="2" />
      <rect x="118" y="150" width="84" height="8" rx="4" fill="#f3f4f6" />
    </>
  );
}

function OutstandingArt() {
  return (
    <>
      <rect x="92" y="58" width="136" height="92" rx="18" fill="#fff" stroke="#f0a8aa" strokeWidth="2.5" />
      <path d="M92 90h136" stroke="#fdecec" strokeWidth="18" />
      <circle cx="196" cy="90" r="14" fill="#fff" stroke="#c6272a" strokeWidth="3" />
      <circle cx="196" cy="90" r="5" fill="#c6272a" />
      <rect x="112" y="118" width="72" height="10" rx="5" fill="#f8d0d1" />
      <rect x="112" y="136" width="48" height="8" rx="4" fill="#f3f4f6" />
    </>
  );
}

function DocumentsArt() {
  return (
    <>
      <rect x="78" y="58" width="96" height="118" rx="14" fill="#fff" stroke="#ececec" strokeWidth="2" transform="rotate(-8 126 117)" />
      <rect x="94" y="84" width="58" height="8" rx="4" fill="#f3f4f6" transform="rotate(-8 123 88)" />
      <rect x="96" y="102" width="44" height="8" rx="4" fill="#f3f4f6" transform="rotate(-8 118 106)" />
      <rect x="146" y="42" width="108" height="132" rx="16" fill="#fff" stroke="#f0a8aa" strokeWidth="2.5" />
      <rect x="146" y="42" width="108" height="28" rx="16" fill="#fdecec" />
      <rect x="146" y="56" width="108" height="14" fill="#fdecec" />
      <rect x="166" y="88" width="68" height="8" rx="4" fill="#f8d0d1" />
      <rect x="166" y="108" width="52" height="8" rx="4" fill="#f8d0d1" />
      <rect x="166" y="128" width="60" height="8" rx="4" fill="#f3f4f6" />
    </>
  );
}

const ART = {
  bookings: BookingsArt,
  customers: CustomersArt,
  outstanding: OutstandingArt,
  documents: DocumentsArt,
};

function EmptyIllustration({ variant }) {
  const Art = ART[variant] || BookingsArt;
  return (
    <svg viewBox="0 0 320 220" role="img" aria-hidden="true" className="agent-empty-art__svg">
      <ellipse cx="160" cy="198" rx="92" ry="12" fill="#f3f4f6" />
      <circle cx="52" cy="58" r="28" fill="#fdecec" />
      <circle cx="274" cy="46" r="22" fill="#eef8f2" />
      <Art />
      <circle cx="228" cy="168" r="26" fill="#c6272a" />
      <path d="M228 157v22M217 168h22" fill="none" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" />
    </svg>
  );
}

export default function EmptyState({ variant = "bookings", title, description, action }) {
  return (
    <div className="text-center py-5 agent-empty-art">
      <EmptyIllustration variant={variant} />
      {title ? <h5 className="mb-2">{title}</h5> : null}
      {description ? (
        <p className={`text-secondary ${action ? "mb-24" : "mb-0"}`}>{description}</p>
      ) : null}
      {action}
    </div>
  );
}
